import { useQuery } from "@tanstack/react-query";
import { queryOptions } from "../../search/hooks";
import api from "../api";
import { yaraQueryKey } from "../queryKeys";

const useGetRulesetTestResults = (rulesetId: string | undefined) => {
  const qp = rulesetId ? { revision_id: rulesetId } : undefined;

  const { data: rulesets, isLoading } = useQuery({
    ...queryOptions,
    queryKey: yaraQueryKey.getLatestTestrunByRuleset(qp),
    queryFn: () => api.getRulesetTestResults(qp),
    select: ({ data }) => data
  });

  const latest = rulesets && rulesets.length ? rulesets[0] : undefined;

  return { rulesets, isLoading, latest };
};

export default useGetRulesetTestResults;
